import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { ScriptsTable } from "@/components/dashboard/ScriptsTable";
import { EmptyState } from "@/components/dashboard/EmptyState";
import { useScripts } from "@/hooks/useScripts";
import { useOfflineDetection } from "@/hooks/useOfflineDetection";
import { useOfflineStorage } from "@/hooks/useOfflineStorage";

export default function Scripts() {
  const { t } = useTranslation();
  const { scripts, loading } = useScripts();
  const { isOffline } = useOfflineDetection();
  const { cachedScripts } = useOfflineStorage();

  const hasScripts = isOffline ? cachedScripts.length > 0 : scripts.length > 0;

  return (
    <div className="space-y-8">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-foreground">
            {t("dashboard.nav.scripts")}
          </h1>
          <p className="text-muted-foreground mt-1">
            {t("dashboard.subtitle")}
          </p>
        </div>
        <Link
          to="/editor/new"
          className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-[#FFD93D] text-black font-bold rounded-xl border-2 border-black shadow-[4px_4px_0_#000] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_#000] transition-all"
        >
          <Plus className="h-5 w-5" />
          {t("dashboard.createScript")}
        </Link>
      </div>

      {/* Scripts Table or Empty State */}
      {loading && !isOffline ? (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
        </div>
      ) : !hasScripts ? (
        <EmptyState />
      ) : (
        <ScriptsTable />
      )}
    </div>
  );
}
